import React, {useEffect}  from "react"
import useSelfCheckinNafigation from 'utils/useSelfCheckinNafigation';
import Flight from "components/Flight/Flight"
import Actions from "components/SelfCheckin/Actions/Actions"
import Footer from "components/SelfCheckin/Footer/Footer"

import { useTranslation } from 'react-i18next';
import {
  SelfCheckinStepEnum, PlatformTypes, SelfBoardingStepEnum
} from "components/shared/enums/global-enums.tsx";

import sitaLogo from 'assets/images/sitaLogo.png'
import aeroportalLogo from 'assets/images/aeroportalLogo.png'

import useStore from 'store/store'
import './Passenger.scss'

export default function Passenger({typeFor, airline}){
  const {t} = useTranslation();

  const airlines = { sita: sitaLogo, portal: aeroportalLogo};
  const [redirect, ] = useSelfCheckinNafigation();
                  
  const selfCheckinChoices = useStore((state)=> state.selfCheckinChoices);
  const scannedElms = useStore((state)=> state.scannedElms);
  let flightRecords = useStore((state)=> state.flightRecords);
  const storeActions = useStore((state)=> state.actions);
  const touchpointType = storeActions.retrieveItem("touchpoint-type");

  let message;
  if (typeFor === SelfCheckinStepEnum.ITEMS_TO_PRINT){
    message = t("CHOOSE ITEMS TO PRINT");
  }

  useEffect(()=>{
    storeActions.setSelfCheckinMode(true);

    if (typeFor !== SelfCheckinStepEnum.PASSENGER){
      return;
    }
    
    const urlParams = {};
    urlParams.random_singapore_only = true;
    urlParams.first_name = scannedElms.first_name;
    urlParams.last_name = scannedElms.last_name;
    urlParams.airline = airline;
    

    if (urlParams.last_name === "TAN" && (urlParams.first_name === "FEI JI VICTORIA" || urlParams.first_name === "JI CHANG OLIVIA")){
      urlParams.pnr = "CA1234";
      urlParams.use_pnr_only = true;
      urlParams.random_singapore_only = null;
    }

    if (typeFor === SelfBoardingStepEnum.PASSENGER_BOARDING) {
      urlParams.gate_decision = true;
      urlParams.airline = scannedElms.airline;
      urlParams.random_singapore_only = true;
      urlParams.location_id = storeActions.retrieveItem("touchpoint");
    }

      storeActions.fetchFlightRecords(
        urlParams, 
        storeActions.preparePanels
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeActions, typeFor, scannedElms, airline]);


  useEffect(()=>{
    if (!flightRecords) return;

    for (var i = 0; i<=flightRecords.length-1; i++) {
      storeActions.setSelfCheckinChoices(i, "fr_id", flightRecords[i].id);
      storeActions.setSelfCheckinChoices(i, "first_name", flightRecords[i].first_name);
      storeActions.setSelfCheckinChoices(i, "last_name", flightRecords[i].last_name);

      if (scannedElms.first_name === flightRecords[i].first_name && scannedElms.last_name === flightRecords[i].last_name){
        storeActions.setSelfCheckinChoices(i, "confirmed", true);
        storeActions.setSelfCheckinChoices(i, "typeFor", SelfCheckinStepEnum.SELECT_BAGS);
      }

    } 
  }, [storeActions, flightRecords, scannedElms]);

  useEffect(()=>{
    if (!scannedElms.first_name && typeFor !== SelfBoardingStepEnum.PASSENGER_BOARDING){
      redirect(0, SelfCheckinStepEnum.IDLE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (

    <div className={`passenger-cover-bloc bg-${airline}`}>
      <div className="font-1-heavy h3 c-txt uppercase white-color">{message}</div>
      <div className="v-space-4"> </div>
      
      <div className="d-f fd-r">
      {
        flightRecords && flightRecords.map((fr, key)=> {
          if (typeFor === SelfCheckinStepEnum.ITEMS_TO_PRINT && !selfCheckinChoices[key].confirmed){
            return null;
          }
          return (
            <div key={key} className="ticket-container">
              <Flight flightRecord={fr}  headerImg={airlines[scannedElms?.airline || airline]}/>
              {selfCheckinChoices[key] && <Actions airline={airline} flightRecord={fr}  sCC={selfCheckinChoices[key]} index={key} gTypeFor={typeFor} />}
            </div>
          )
        }) 
      }
      </div>
      
      <div className="v-space-8"> </div>
      <Footer backStep={
        (typeFor === SelfCheckinStepEnum.PASSENGER)? -2:
        (typeFor === SelfCheckinStepEnum.ITEMS_TO_PRINT && (storeActions.checkinChoicesBags().length === 0 || touchpointType === PlatformTypes.NON_POPPS)) ? -3 : -1
      }
      />
    </div>
    
    )
}